import type { ComponentType, SVGProps } from 'react'
import {
  AcademicCapIcon,
  BeakerIcon,
  BoltIcon,
  BookOpenIcon,
  BugAntIcon,
  BuildingStorefrontIcon,
  CircleStackIcon,
  CloudIcon,
  CpuChipIcon,
  FaceSmileIcon,
  FireIcon,
  GlobeAsiaAustraliaIcon,
  HeartIcon,
  HomeIcon,
  MapPinIcon,
  MicrophoneIcon,
  MoonIcon,
  MusicalNoteIcon,
  PaperAirplaneIcon,
  RocketLaunchIcon,
  SparklesIcon,
  SpeakerWaveIcon,
  SunIcon,
  TruckIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/solid'
import { SOUNDSCAPE_BY_ID, type SoundscapeCategoryId, type SoundscapeId } from './catalog'

type IconType = ComponentType<SVGProps<SVGSVGElement>>

const categoryIcons: Record<SoundscapeCategoryId, IconType> = {
  nature: SunIcon, rain: CloudIcon, animals: BugAntIcon, urban: BuildingStorefrontIcon, places: HomeIcon, transport: TruckIcon, things: MicrophoneIcon,
  noise: SpeakerWaveIcon,
}

const groupIcons: Record<string, IconType> = {
  waves: BeakerIcon,
  birds: PaperAirplaneIcon,
  fire: FireIcon,
  rain: CloudIcon,
  stream: BeakerIcon,
  village: HomeIcon,
  forest: SunIcon,
  road: TruckIcon,
  frogs: BugAntIcon,
  night: MoonIcon,
  thunder: BoltIcon,
  waterfall: BeakerIcon,
  snow: CloudIcon,
  basketball: AcademicCapIcon,
  bells: MusicalNoteIcon,
  cafe: BuildingStorefrontIcon,
  chants: MusicalNoteIcon,
  chicken: PaperAirplaneIcon,
  conversation: FaceSmileIcon,
  farm: HomeIcon,
  airplane: PaperAirplaneIcon,
  playground: MapPinIcon,
  street: BuildingStorefrontIcon,
  supermarket: BuildingStorefrontIcon,
  train: TruckIcon,
  subway: TruckIcon,
  barber: WrenchScrewdriverIcon,
  tapping: CircleStackIcon,
  trigger: SparklesIcon,
  whisper: MicrophoneIcon,
  bubbles: BeakerIcon,
  cat: HeartIcon,
  ceiling_fan: SparklesIcon,
  clock: CircleStackIcon,
  deep_sea: GlobeAsiaAustraliaIcon,
  fireworks: SparklesIcon,
  hair_dryer: SparklesIcon,
  keyboard: CpuChipIcon,
  chips: AcademicCapIcon,
  printer: CpuChipIcon,
  space: RocketLaunchIcon,
  table_fan: SparklesIcon,
  vacuum: WrenchScrewdriverIcon,
  wind_chimes: MusicalNoteIcon,
  brown_noise: SpeakerWaveIcon,
  pink_noise: SpeakerWaveIcon,
  white_noise: SpeakerWaveIcon,
  engine: TruckIcon,
  boat: BeakerIcon,
  swimming: BeakerIcon,
  whale: GlobeAsiaAustraliaIcon,
  breath: FaceSmileIcon,
  magma: FireIcon,
  walk: MapPinIcon,
  lofi_chill: MusicalNoteIcon,
  lofi_study: BookOpenIcon,
  lofi_sleep: MoonIcon,
  lofi_jazz: MusicalNoteIcon,
  lofi_piano: MusicalNoteIcon,
}

export function SoundscapeIcon({ id, groupId, className }: { id?: SoundscapeId; groupId?: string; className?: string }) {
  const definition = id ? SOUNDSCAPE_BY_ID.get(id) : undefined
  const resolvedGroupId = groupId || definition?.groupId
  const Icon = (resolvedGroupId && groupIcons[resolvedGroupId]) || categoryIcons[definition?.category || 'nature']
  return <Icon className={className} aria-hidden="true" />
}
